/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "abac0fdc79295cf375115e2805ef12f40b5d0136";
